import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Chip,
  Dialog,
  Divider,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CustomButton from "../../../reusableComponents/CustomButton";
import { useAuth } from "../../../context/API_Client";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import { nameRegex } from "../../../reusableComponents/constants";

export default function InviteUser({
  open,
  onClose,
  createUser,
  setCreateUser,
  rolesData,
}) {
  const { createUsers, getBusinessUnits } = useAuth();
  const [fullName, setFullName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [dropdownContent, setDropdownContent] = useState("");
  const [error, setError] = useState("");
  const [businessUnitsData, setBusinessUnitsData] = useState("");
  const [selectedBusinessUnits, setSelectedBusinessUnits] = useState([]);
  const loginUser = localStorage?.getItem("userDetails");
  const userObject = JSON.parse(loginUser);
  useEffect(() => {
    getBusinessUnits(
      function (data) {
        const sortedUnits = data.sort((a, b) => a.name.localeCompare(b.name))
        setBusinessUnitsData(sortedUnits);
      },
      function (errorMsg) {
        customToast("error", "high", errorMsg);
      }
    );
  }, []);

  const handleBusinessUnit = (event, value) => {
    const selectedCodes = value.map((option) => option.code);
    setSelectedBusinessUnits(selectedCodes);
  };
  const handleFullNameChange = (e) => {
    const inputValue = e.target.value;
    setFullName(inputValue);
    const isValidName = nameRegex.test(inputValue);
    setError(isValidName ? "" : "Special Characters are not allowed");
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setDropdownContent(value);
  };

  const emptyAllFields = () => {
    setError("");
    setFullName("");
    setEmailId("");
    setDropdownContent("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      onClose();
      emptyAllFields();
    }
  };
  const handleEmailAddress = (e) => {
    const inputValue = e.target.value;
    setEmailId(inputValue);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(inputValue);
    setEmailError(isValidEmail ? "" : "Please enter correct Email Id");
  };

  const handleClickCrossButton = () => {
    onClose();
    emptyAllFields();
  };

  const handleSubmitInviteUsers = () => {
    createUsers(
      {
        name: fullName,
        roles: [dropdownContent],
        email: emailId,
        businessUnits: selectedBusinessUnits,
      },
      function (data) {
        customToast("success", "high", "User invited successfully");

        if (data) {
          setCreateUser(!createUser);
          onClose();
          emptyAllFields();
        }
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };

  const handleCancelButton = () => {
    onClose();
    emptyAllFields();
  };



  return (
    <>
      <Dialog className="inviteModal" open={open} onKeyDown={handleKeyDown}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "6px",
            padding: "24px 24px 0px 24px",
          }}
        >
          <Typography className="SemiboldTwenty font-black-highest">
            Invite User
          </Typography>
          <img
            src="/assets/ic_twotone-close.svg"
            alt="cross"
            onClick={() => handleClickCrossButton()}
            style={{ cursor: "pointer" }}
          />
        </div>
        <Typography
          className="labelRegular font-black-high"
          style={{ padding: "0px 24px" }}
        >
          Extend invitations to your team members, granting them access to
          BoxPay's collaborative dashboard
        </Typography>
        <Divider
          style={{
            margin: "16px 24px",
          }}
        />

        <div
          style={{
            height: "auto",
            overflowY: "scroll",
            padding: "0px 24px",
          }}
        >
          <div
            style={{
              marginLeft: "0px",
              marginRight: "0px",
            }}
          >
            <div>
              <Typography
                className="labelRegular"
                style={{
                  color: "var(--global-neutral-grey-1100, #2D2B32)",
                }}
              >
                Email Address*
              </Typography>
              <TextField
                variant="outlined"
                placeholder="Enter Email Address"
                id="outlined-basic"
                sx={{
                  borderRadius: "8px",
                  marginTop: "8px",
                  width: "100%",
                  height: "42px",
                }}
                size="small"
                fullWidth
                value={emailId}
                onChange={(e) => handleEmailAddress(e)}
              />
              {emailError?.length > 0 && emailId?.length > 0 && (
                <FormHelperText
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "2px",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "12px", width: "12px", marginLeft: "4px" }}
                  />
                  {emailError}
                </FormHelperText>
              )}
            </div>
            <div
              style={{
                marginTop: "32px",
              }}
            >
              <Typography
                className="labelRegular"
                style={{
                  color: "var(--global-neutral-grey-1100, #2D2B32)",
                }}
              >
                Full Name*
              </Typography>
              <TextField
                variant="outlined"
                placeholder="Enter Name"
                id="outlined-basic"
                sx={{
                  borderRadius: "8px",
                  marginTop: "8px",
                  width: "100%",
                  height: "42px",
                }}
                size="small"
                fullWidth
                value={fullName}
                onChange={handleFullNameChange}
              />
              {error?.length > 0 && (
                <FormHelperText
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "2px",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "12px", width: "12px", marginLeft: "4px" }}
                  />
                  {error}
                </FormHelperText>
              )}
            </div>
            <div
              className="multiselectInput"
              style={{
                marginTop: "32px",
                marginBottom: "32px",
              }}
            >
              <Typography
                className="labelRegular"
                style={{
                  color: "var(--global-neutral-grey-1100, #2D2B32)",
                }}
              >
                Business Unit(s) {userObject?.businessUnits && "*"}
              </Typography>
              <Autocomplete
                multiple
                limitTags={1}
                options={businessUnitsData}
                getOptionLabel={(option) => option.name}
                className="multiselect"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={
                      selectedBusinessUnits.length === 0
                        ? "Select Business Unit"
                        : ""
                    }
                  />
                )}
                onChange={handleBusinessUnit}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      key={index}
                      label={option.name}
                      {...getTagProps({ index })}
                      style={{
                        maxWidth: 250,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    />
                  ))
                }
              />
            </div>
            <div
              style={{
                marginTop: "32px",
                marginBottom: "32px",
              }}
            >
              <Typography
                className="labelRegular"
                style={{
                  color: "var(--global-neutral-grey-1100, #2D2B32)",
                }}
              >
                Select Role*
              </Typography>
              <Select
                className="monthDropdown dropdown"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={dropdownContent}
                onChange={(e) => handleChange(e)}
                style={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: 400,
                  height: "40px",
                  color: "var(--character-title-85, rgba(0, 0, 0, 0.85))",
                  width: "100%",
                  marginTop: "8px",
                }}
                classes={{ icon: "custom-dropdown-icon" }}
                renderValue={(selected) => (
                  <div className="itemNameStyling">
                    {selected
                      ? rolesData?.find((item) => item.id === selected)?.name
                      : "Select Role"}
                  </div>
                )}
                displayEmpty
              >
                {rolesData?.map((item, idx) => {
                  return (
                    <MenuItem key={idx} value={item?.id}>
                      {item?.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </div>
          </div>
        </div>
        <div
          style={{
            paddingBottom: "24px",
            paddingTop: "24px",
            paddingRight: "24px",
            display: "flex",
            justifyContent: "end",
            boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
          }}
        >
          <CustomButton
            variant={"outlined"}
            size={"sm"}
            type={"secondary"}
            text={"Cancel"}
            onClick={() => handleCancelButton()}
          />
          <div style={{ marginLeft: "8px" }}>
            <CustomButton
              variant={"contained"}
              size={"sm"}
              type={"secondary"}
              text={"Save"}
              disabled={
                fullName?.length == 0 ||
                error?.length > 0 ||
                emailError?.length > 0 ||
                emailId?.length === 0 ||
                dropdownContent?.length === 0 ||
                (userObject?.businessUnits?.length &&
                  selectedBusinessUnits?.length === 0)
              }
              onClick={handleSubmitInviteUsers}
            />
          </div>
        </div>
      </Dialog>
    </>
  );
}
